import { createAction } from '@reduxjs/toolkit';

export const SetSortFilterAction = createAction<string>('projectList/SetSortFilterAction');

export const SetKeywordFilterAction = createAction<string>('projectList/SetKeywordFilterAction');

export const SetOrderSortFilterAction = createAction<ProjectOrderSortFilter>('projectList/SetOrderSortFilterAction');

// Dispatched only by the dashboard's own filter dropdown - deliberately separate from
// SetOrderSortFilterAction, which other features (e.g. orderHistory) also dispatch for
// unrelated reasons and must not be able to mark as a deliberate dashboard choice.
export const MarkOrderSortFilterTouchedAction = createAction('projectList/MarkOrderSortFilterTouchedAction');

export const SetPageAction = createAction<number>('projectList/SetPage');

export const GetProjectsStartAction = createAction('projectList/GetProjectsStart');

export const GetProjectsSuccessAction = createAction<IProjectSuccess>('projectList/GetProjectsSuccess');

export const GetProjectsFailedAction = createAction<string>('projectList/GetProjectsFailed');

export const GetMapCoordinatesStartAction = createAction('projectList/GetMapCoordinatesStart');

// The server's without-location count may ride along; the client counts from the set itself.
export const GetMapCoordinatesSuccessAction = createAction<{ coordinates: IProjectMapCoordinate[]; requestKey?: string; missingLocationCount?: number }>('projectList/GetMapCoordinatesSuccess');

export const GetMapCoordinatesFailedAction = createAction<string>('projectList/GetMapCoordinatesFailed');
export const MapCoordinatesFetchDroppedAction = createAction('projectList/MapCoordinatesFetchDropped');
export const InvalidateMapCoordinatesAction = createAction('projectList/InvalidateMapCoordinates');

export const SetShowMapviewAction = createAction<boolean>('projectList/SetShowMapviewAction');
export const SetSelectedPinProjectAction = createAction<string | null>('projectList/SetSelectedPinProjectAction');
export const SetPinGroupAction = createAction<{ ids: string[] }>('projectList/SetPinGroupAction');
export const SetMapFocusAction = createAction<{ kind: 'project'; id: string }>('projectList/SetMapFocusAction');
export const SetEsriCameraAction = createAction<IEsriCamera | null>('projectList/SetEsriCameraAction');
export const SetRailViewAction = createAction<{ scrollTop: number; mountedCount: number } | null>('projectList/SetRailViewAction');

// The dashboard's own view state (AUT-6432): the project to land on when the map closes, rows
// or cards, and the folder the map is scoped to.
export const ClearMapPickToRevealAction = createAction('projectList/ClearMapPickToRevealAction');
export const SetProjectViewModeAction = createAction<ProjectViewMode>('projectList/SetProjectViewModeAction');
export const SetMapFolderAction = createAction<string | null>('projectList/SetMapFolderAction');

export const SetProjectsAction = createAction<any>('projectList/SetProjectsAction');

// A project was moved into a folder (or unassigned). The grid renders the complete set, so the
// move has to reach it: the badge follows the new folderId, and the card leaves the set when the
// active filter no longer admits it.
export const AssignProjectToFolderAction = createAction<{ projectId: string; folderId?: string }>('projectList/AssignProjectToFolderAction');

export const SetLoadAllAction = createAction<boolean>('projectList/SetLoadAllAction');

export const SetLoadNewAction = createAction<boolean>('projectList/SetLoadNewAction');

export const SetThumbnailAction = createAction<{ projectId: string, thumbnail: string }>('projectList/SetThumbnailAction');

export const DeleteProjectsStartAction = createAction<string>('projectList/DeleteProjectsStartAction');

export const DeleteProjectsSuccessAction = createAction<string>('projectList/DeleteProjectsSuccessAction');

export const DeleteProjectsFailedAction = createAction<string>('projectList/DeleteProjectsFailedAction');

// opsTrainer is part of the payload UpdateProjectNameThunk actually sends - it says whether the
// editor is an ops trainer, and so which name was edited. Declared here rather than cast at the
// reducer, so the branch that reads it is type-checked instead of asserted.
export const UpdateProjectNameAction = createAction<IProject & { opsTrainer?: boolean }>('project/UpdateProjectNameAction');
export const UpdateProjectListTifFileAction = createAction<ITifFile>('projectList/UpdateProjectListTifFileAction');
export const UpdateProjectListLasFileAction = createAction<ILasFile>('projectList/UpdateProjectListLasFileAction');

export const DeleteProjectListTifFileAction = createAction<any>('projectList/DeleteProjectListTifFileAction');
export const DeleteProjectListLasFileAction = createAction<any>('projectList/DeleteProjectListLasFileAction');

export const UpdateProjectListImageryRequestSuccessAction = createAction<IImageryRequest>('projectList/UpdateProjectListImageryRequestSuccessAction');
